






import Vue from "vue";
import coreApiClient from "@/services/apis/coreApiClient";
import userManager from "@/services/userManager";
import paymentReceiveAccountStatuses from "@/constants/paymentReceiveAccountStatuses";
import makeSelectOptions from "@common/util/makeSelectOptions";

export default Vue.extend({
  data() {
    return {
      self: this,
      tableOptions: {
        attrs: {
          "item-key": "_id",
          "sort-by": "createdTime",
          "sort-desc": true,
        },
        content: {
          name: "Quản lý Tài khoản ngân hàng nhận tiền",
          urlEnabled: true,
          search: {},
          displayFields: {
            name: {
              text: "Tên",
              sortable: true,
            },
            cardNumber: {
              text: "Số thẻ",
              sortable: true,
            },
            bankName: {
              text: "Tên ngân hàng",
              sortable: true,
            },
            status: {
              text: "Trạng thái",
              options: {
                label: true,
                transform(value) {
                  return paymentReceiveAccountStatuses[value];
                },
              },
            },
            startTime: {
              text: "Ngày bắt đầu",
              sortable: true,
              options: {
                filter: "dateTime",
              },
            },
            endTime: {
              text: "Ngày kết thúc",
              sortable: true,
              options: {
                filter: "dateTime",
              },
            },
            usageMethod: {
              text: "Cách thức sử dụng",
            },
            isMainAccount: {
              text: "Tài khoản chính",
              options: {
                boolean: true,
              },
            },
            approved: {
              text: "Đã duyệt",
              sortable: true,
              options: {
                boolean: true,
              },
            },
            description: {
              text: "Mô tả",
            },
            createdTime: {
              text: "Ngày tạo",
              sortable: true,
              options: {
                filter: "dateTime",
              },
            },
            action: {},
          },
          topActionButtons: {
            insert: userManager.checkRole(["kt"]) && {},
          },
          template: {
            itemActionButtons: {
              edit: userManager.checkRole(["kt"]) && {
                target: {
                  dialog: {
                    ext: {
                      subTitleMaker: "name",
                    },
                  },
                },
              },
              delete: userManager.checkRole(["admin"]) && {},
            },
          },
        },
        ext: {
          dataProvider: {
            async findAll(options) {
              const { items, count } = await coreApiClient.call("paymentReceiveAccounts", "findAll", options, undefined, undefined, "viewProtectedPage3");
              return [items, count];
            },
            async insert(item) {
              return await coreApiClient.call("paymentReceiveAccounts", "create", undefined, item, undefined, "viewProtectedPage3");
            },
            async update(item) {
              return await coreApiClient.call(
                "paymentReceiveAccounts",
                "update",
                {
                  id: item._id,
                },
                {
                  data: item,
                },
                undefined,
                "viewProtectedPage3"
              );
            },
            async delete(item) {
              return await coreApiClient.call(
                "paymentReceiveAccounts",
                "delete",
                {
                  id: item._id,
                },
                undefined,
                undefined,
                "viewProtectedPage3"
              );
            },
          },
          default: {
            defaultInputs: {
              name: {
                attrs: {
                  label: "Tên",
                  required: true,
                },
              },
              cardNunber: {
                attrs: {
                  label: "Số thẻ",
                  required: true,
                },
              },
              bankName: {
                attrs: {
                  label: "Tên ngân hàng",
                  required: true,
                },
              },
              status: {
                type: "select",
                attrs: {
                  label: "Trạng thái",
                  items: makeSelectOptions(paymentReceiveAccountStatuses),
                },
                ext: {
                  defaultValue: "hd",
                },
              },
              startTime: {
                type: "XDateTimePicker",
                attrs: {
                  label: "Ngày bắt đầu",
                },
              },
              endTime: {
                type: "XDateTimePicker",
                attrs: {
                  label: "Ngày kết thúc",
                },
              },
              usageMethod: {
                attrs: {
                  label: "Cách thức sử dụng",
                },
              },
              isMainAccount: {
                type: "boolean",
                attrs: {
                  label: "Tài khoản chính",
                },
              },
              approved: {
                type: "boolean",
                attrs: {
                  label: "Đã duyệt",
                },
                ext: {
                  condition() {
                    return userManager.getUserInfo().super;
                  },
                },
              },
              description: {
                type: "textLarge",
                attrs: {
                  label: "Mô tả",
                },
              },
            },
            insertForm: {
              content: {
                fieldNames: ["name", "cardNumber", "bankName", "status", "usageMethod", "isMainAccount", "approved", "description", "startTime", "endTime"],
              },
            },
            editForm: {
              content: {
                fieldNames: ["name", "cardNumber", "bankName", "status", "usageMethod", "isMainAccount", "approved", "description", "startTime", "endTime"],
              },
            },
            delete: {
              confirmDisplayField: "name",
            },
          },
        },
      },
    };
  },
});
